import Galaxie from './Galaxie.jsx';

export default Galaxie;
